import { render, staticRenderFns } from "./BulkActions.vue?vue&type=template&id=3510ffd0&scoped=true&"
import script from "./BulkActions.vue?vue&type=script&lang=js&"
export * from "./BulkActions.vue?vue&type=script&lang=js&"
import style0 from "./BulkActions.vue?vue&type=style&index=0&id=3510ffd0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3510ffd0",
  null
  
)

export default component.exports